import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";
import { useLang } from "@/i18n";

export const FloatingWhatsApp = () => {
    const { t } = useLang();
    return (
        <a
            href={waLink(t("wa.message"))}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="WhatsApp"
            className="group fixed z-50 bottom-24 right-4 md:bottom-6 md:right-6 flex items-center gap-3"
        >
            <span className="hidden md:block opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300 bg-ink/90 backdrop-blur-md border border-gold/30 text-gold-soft text-xs font-light px-4 py-2 rounded-sm pointer-events-none">
                {t("float.tooltip")}
            </span>
            <span className="relative w-14 h-14 rounded-full bg-wa border-2 border-gold/70 flex items-center justify-center shadow-[0_0_24px_rgba(18,140,126,0.5)] group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(212,175,55,0.45)] transition-[transform,box-shadow] duration-300">
                <MessageCircle className="w-6 h-6 text-[#f4f0e6]" />
            </span>
        </a>
    );
};
